import { useMutation, useQueryClient } from '@tanstack/react-query';

import type {
  SocialConnection,
  SocialConnectionList,
  SocialProvider,
} from '@nucleus-commerce/api-client/admin';

import { socialApi } from '../api/social-api';

import { socialKeys } from './social-keys';

/**
 * One click: the backend checks the storefront serves the network's file, then asks the network to
 * verify. A refusal is not an error here: it comes back as `website.status: failed` with a reason
 * the step explains, so only missing preconditions (scope, domain) surface as toasts.
 */
export function useClaimWebsite(storeId: string, provider: SocialProvider) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => socialApi.claimWebsite(storeId, provider),
    onSuccess: (connection: SocialConnection) => {
      queryClient.setQueryData<SocialConnectionList>(socialKeys.connections(storeId), (list) =>
        list
          ? { items: list.items.map((item) => (item.id === connection.id ? connection : item)) }
          : list,
      );
      return queryClient.invalidateQueries({ queryKey: socialKeys.catalog(storeId, provider) });
    },
  });
}
